import React, { useState, useEffect } from 'react';

import { Dropdown } from 'semantic-ui-react';

function DropdownSelect(props) {
    const [selectedValue, setSelectedValue] = useState(props.data.value);
    const [lastSelected, setLastSelected] = useState(null);

    const lang = props.lang;

    function onChangeSelectedValue(e, data) {
        setLastSelected(selectedValue);
        setSelectedValue(data.value);
        if (props.data.id === "language") {
            props.onChangeLang(data.value);
        }
        props.onChange(props.data.id, data.value);
    }

    useEffect(() => {
        if (lastSelected !== props.data.value) {
            setSelectedValue(props.data.value);
        }
    }, [props])

    return (
        <>
            <p style={{ margin: "auto 0" }}>{props.data.description[lang]}</p>
            <Dropdown
                onChange={onChangeSelectedValue}
                fluid
                value={selectedValue}
                selection
                search={props.data.search}
                id={props.data.id}
                options={props.data.options[lang]}
            />
        </>
    );

}

export default DropdownSelect;